export type PasswordRule = {
  id: 'length' | 'case' | 'number' | 'symbol';
  label: string;
  test: (value: string) => boolean;
};

/** Mismas reglas que el cambio de contraseña de /mi-perfil en adipa-front. */
export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'Al menos 8 caracteres', test: (value) => value.length >= 8 },
  {
    id: 'case',
    label: 'Una mayúscula y una minúscula',
    test: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value),
  },
  { id: 'number', label: 'Un número', test: (value) => /\d/.test(value) },
  { id: 'symbol', label: 'Un símbolo (!@#$...)', test: (value) => /[^A-Za-z0-9]/.test(value) },
];

export function passesPasswordRules(value: string) {
  return PASSWORD_RULES.every((rule) => rule.test(value));
}
